import styled from 'styled-components'

import { FlowButton } from '../FlowButton'

export const StyledFlowSubscriptions = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
  `,
  SecondaryAction: styled.p`
    margin-top: 16px;
  `,
  ActionButton: styled(FlowButton)`
    & + & {
      margin-top: 12px;
    }
  `,
}
